/** 按媒资 URL 的末级目录识别播放器，域名和前置路径可变。三个前端保持相同规则。 */
export function dramaVersion(ossRoot: string | null | undefined): 'A' | 'B' | null {
  if (!ossRoot)
    return null
  try {
    const path = new URL(ossRoot).pathname.replace(/\/+$/, '')
    if (path.endsWith('/build'))
      return 'A'
    if (path.endsWith('/build-v3'))
      return 'B'
  }
  catch { /* 无效媒资 URL 不猜版本 */ }
  return null
}
